// Sayfa Yetkileri (/sayfa-yetkileri) ve pencereleri (şifre, mesaj, kişi
// listeleri, kullanım istatistikleri). Menü başlıkları kenar çubuğundaki gibi
// yola göre çevrilir; kayıtlı roller olduğu gibi gösterilir.
const pageAccess = {
  page: {
    title: 'Sayfa Yetkileri',
    subtitle: 'Bir çalışan seçin, erişebileceği sayfaları görün ve dilediğiniz sayfayı açıp kapatın. Yaptığınız seçimler kaydedilir.',
  },
  actions: {
    showPassive: 'Pasifleri Göster',
    hidePassive: 'Pasifleri Gizle',
    showPassiveHint: 'Pasif çalışanları listelere dahil et',
    hidePassiveHint: 'Pasif çalışanları listelerden gizle',
    stats: 'Kullanım İstatistikleri',
    statsHint: 'Giriş sayıları, çevrimiçi süreler ve en aktif kullanıcılar',
  },
  tiles: {
    employees: 'Çalışan',
    employeesShort: 'Çalışan',
    online: 'Çevrimiçi Olanlar',
    onlineShort: 'Çevrimiçi',
    admins: 'Adminler',
    adminsShort: 'Admin',
    restricted: 'Kısıtlı Adminler',
    restrictedShort: 'Kısıtlı',
  },
  roles: {
    employee: 'Çalışan',
  },
  list: {
    label: 'Çalışan listesi',
    search: 'Çalışan ara…',
    filterLabel: 'Çalışan süzgeci',
    all: 'Tümü',
    online: 'Çevrimiçi',
    granted: 'Ek yetkili',
    grantedHint: 'Bu ekrandan ek sayfa yetkisi verilmiş çalışanlar',
    loading: 'Yükleniyor…',
    empty: 'Çalışan bulunamadı',
    count_one: '{{count}} çalışan',
    count_other: '{{count}} çalışan',
    accessTitle: 'Erişebildiği sayfa sayısı',
    onlineTitle: 'Çevrimiçi',
    offlineTitle: 'Çevrimdışı',
    passive: 'Pasif',
  },
  editor: {
    label: 'Sayfa yetkileri',
    placeholderTitle: 'Bir çalışan seçin',
    placeholderText: 'Listeden bir çalışan seçtiğinizde, erişebildiği sayfaları burada düzenleyebilirsiniz.',
    back: 'Çalışanlar',
    password: 'Şifre Değiştir',
    passwordHint: 'Bu kullanıcının şifresini değiştir',
    summary: '/ {{total}} sayfa',
    summaryHint: 'Erişebildiği sayfa sayısı (kaydedilmemiş değişiklikler dahil)',
    legend: {
      role: 'Rol ile erişim',
      special: 'Özel erişim (kod)',
      granted: 'Eklendi',
      none: 'Erişim yok',
    },
    search: 'Sayfa ara…',
    filterLabel: 'Sayfa süzgeci',
    filter: {
      all: 'Tümü',
      on: 'Erişimi olan',
      off: 'Erişimi olmayan',
    },
    noMatch: 'Arama ile eşleşen sayfa yok',
    tag: {
      role: 'Rol',
      special: 'Kod',
      granted: 'Eklendi',
    },
    locked: 'Bu erişim rol veya kod tarafından sağlanıyor, buradan kaldırılamaz',
    remove: 'Bu sayfayı kaldır',
    add: 'Bu sayfayı ekle',
    addAll: 'Tümünü ekle',
    removeAll: 'Tümünü kaldır',
    groupHint: 'Bu menüdeki, rol veya kod ile gelmeyen sayfaların hepsi',
    unsaved_one: '{{count}} değişiklik kaydedilmedi',
    unsaved_other: '{{count}} değişiklik kaydedilmedi',
    reset: 'Sıfırla',
    save: 'Kaydet',
    saving: 'Kaydediliyor…',
  },
  switchConfirm: {
    title: 'Kaydedilmemiş değişiklikler',
    message: '{{name}} için yaptığınız değişiklikler kaydedilmedi. Kaydetmeden devam ederseniz bu değişiklikler kaybolur.',
    confirm: 'Kaydetmeden Devam Et',
    cancel: 'Geri Dön',
  },
  people: {
    admins: {
      title: 'Admin Yetkili Çalışanlar',
      empty: 'Yetkilendirmesi "admin" olan çalışan bulunmuyor.',
    },
    restricted: {
      title: 'Kısıtlı Admin Yetkili Çalışanlar',
      empty: 'Yetkilendirmesi "Kısıtlı Admin" olan çalışan bulunmuyor.',
    },
    online: {
      title: 'Çevrimiçi Kullanıcılar',
      empty: 'Şu anda çevrimiçi kullanıcı bulunmuyor.',
    },
    count_one: '{{count}} kişi',
    count_other: '{{count}} kişi',
    loading: 'Yükleniyor…',
    editHint: 'Bu çalışanın sayfa yetkilerini düzenle',
    message: 'Mesaj',
    messageHint: 'Bu çalışana mesaj gönder',
    access: 'Yetkiler',
    noPage: 'Sayfa bilgisi henüz gelmedi',
    close: 'Kapat',
  },
  activity: {
    login: 'Giriş ekranı',
    loginGroup: 'Ana Sayfa',
    other: 'Diğer',
  },
  message: {
    title: 'Mesaj Gönder',
    noEmail: 'E-posta tanımlı değil',
    label: 'Mesaj',
    placeholder: 'Mesajınızı yazın…',
    hint: 'Mesaj, çalışanın mesaj kutusuna düşer ve oradan cevaplayabilir. Göndermek için Ctrl + Enter.',
    cancel: 'Vazgeç',
    send: 'Gönder',
    sending: 'Gönderiliyor…',
  },
  password: {
    title: 'Şifre Değiştir',
    label: 'Yeni şifre',
    placeholder: 'En az 6 karakter',
    generate: 'Oluştur',
    generateHint: 'Güçlü bir şifre üret',
    sendEmail: 'Yeni şifreyi kullanıcıya e-posta ile gönder',
    cancel: 'İptal',
    submit: 'Şifreyi Güncelle',
    saving: 'Kaydediliyor…',
    errors: {
      noEmail: 'Bu çalışanın e-posta adresi yok, şifre değiştirilemez.',
      tooShort: 'Şifre en az 6 karakter olmalıdır.',
      noSession: 'Oturum bulunamadı. Lütfen yeniden giriş yapın.',
      failed: 'Şifre güncellenemedi.',
      generic: 'Şifre güncellenirken bir hata oluştu.',
    },
  },
  time: {
    justNow: 'az önce',
    justNowCap: 'Az önce',
    minutes: '{{m}} dk',
    hours: '{{h}} sa',
    hoursMinutes: '{{h}} sa {{m}} dk',
    seconds: '{{s}} sn',
    never: 'Hiç aktivite yok',
    minutesAgo: '{{m}} dk önce',
    hoursAgo: '{{h}} saat önce',
    daysAgo: '{{d}} gün önce',
  },
  stats: {
    title: 'Kullanım İstatistikleri',
    subtitle: 'Son 30 günün giriş kayıtları ve oturum süreleri',
    tabsLabel: 'İstatistik görünümü',
    overview: 'Genel Bakış',
    users: 'Kullanıcı Detayları',
    loading: 'Giriş kayıtları yükleniyor…',
    error: 'Giriş geçmişi yüklenirken bir hata oluştu, gösterilen veriler eksik olabilir.',
    online: 'Şu An Çevrimiçi',
    onlineShort: 'Çevrimiçi',
    active30: 'Aktif Kullanıcı (30 gün)',
    active30Short: 'Aktif (30 gün)',
    logins30: 'Toplam Giriş (30 gün)',
    logins30Short: 'Giriş (30 gün)',
    totalOnline: 'Toplam Çevrimiçi Süre',
    totalOnlineShort: 'Toplam süre',
    chartTitle: 'Günlük Girişler (Son {{days}} Gün)',
    chartBar: '{{date}}: {{count}} giriş',
    top: 'En Aktif Kullanıcılar (30 gün)',
    topEmpty: 'Son 30 günde giriş kaydı yok.',
    topMeta: '{{logins}} giriş · {{duration}}',
    least: 'Aktif Olmayanlar (30 günde giriş yok)',
    leastEmpty: 'Tüm kullanıcılar son 30 günde en az bir kez giriş yaptı.',
    lastActivity: 'Son aktivite: {{time}}',
    columns: {
      user: 'Kullanıcı',
      status: 'Durum',
      lastActivity: 'Son Aktivite',
      logins30: 'Giriş (30g)',
      totalLogins: 'Toplam Giriş',
      totalOnlineMs: 'Toplam Süre',
    },
    statusOnline: 'Çevrimiçi',
    statusOffline: 'Çevrimdışı',
    logins7: 'Giriş (7 gün)',
    avgSession: 'Ort. Oturum',
    activeSession: 'Aktif Oturum',
    lastSession: 'Son Oturum',
    recentTitle: 'Son Girişler (30 gün içinde {{count}} kayıt)',
    recentEmpty: 'Son 30 günde giriş kaydı bulunmuyor.',
    more: '+ {{count}} giriş daha',
    sessionRecord: 'Oturum kaydı',
    unknownDevice: 'Bilinmeyen cihaz',
    browser: 'Tarayıcı',
    expand: 'Ayrıntıları göster',
    collapse: 'Ayrıntıları gizle',
    footnote: 'Giriş sayıları login geçmişi kayıtlarından, çevrimiçi süreler ise oturum takibinden hesaplanır. Süre takibi yeni etkinleştirildiyse geçmiş oturumlar toplamlara dahil değildir.',
    close: 'Kapat',
  },
  toast: {
    loadError: 'Çalışanlar yüklenirken bir hata oluştu',
    noSession: 'Oturum bilgisi bulunamadı, mesaj gönderilemedi.',
    noReceiverEmail: 'Bu çalışanın e-posta adresi tanımlı değil, mesaj gönderilemez.',
    messageSent: 'Mesaj {{name}} kişisine gönderildi',
    messageError: 'Mesaj gönderilirken bir hata oluştu',
    saved: '{{name}} için sayfa yetkileri kaydedildi',
    saveError: 'Yetkiler kaydedilirken bir hata oluştu',
    passwordMailed: 'Şifre güncellendi ve e-posta ile gönderildi.',
    passwordMailFailed: 'Şifre güncellendi fakat e-posta gönderilemedi. Bilgiyi manuel iletiniz.',
    passwordUpdated: 'Şifre başarıyla güncellendi.',
  },
};

export default pageAccess;
